export interface MovieItem {
  id: string;
  slug: string;
  title: string;
  titleEn: string;
  year: number;
  category: string;
  categorySlug: string;
  rating: number;
  poster: string;
  description: string;
  duration: string;
  director: string;
  actors: string[];
  region: string;
  tags: string[];
  isHot: boolean;
  isNew: boolean;
  updateDate: string;
}

export const categories = [
  { name: '全部', slug: 'all' },
  { name: '动作片', slug: 'action' },
  { name: '喜剧片', slug: 'comedy' },
  { name: '爱情片', slug: 'romance' },
  { name: '科幻片', slug: 'scifi' },
  { name: '恐怖片', slug: 'horror' },
  { name: '剧情片', slug: 'drama' },
  { name: '动画片', slug: 'animation' },
  { name: '纪录片', slug: 'documentary' },
  { name: '电视剧', slug: 'tv' },
  { name: '综艺', slug: 'variety' },
  { name: '动漫', slug: 'anime' },
];

export const heroMovies: MovieItem[] = [
  {
    id: '1',
    slug: 'liu-lang-di-qiu-3',
    title: '流浪地球3',
    titleEn: 'The Wandering Earth 3',
    year: 2026,
    category: '科幻片',
    categorySlug: 'scifi',
    rating: 9.2,
    poster: 'https://readdy.ai/api/search-image?query=Epic%20Chinese%20sci-fi%20movie%20poster%2C%20astronaut%20facing%20giant%20planet%20in%20deep%20space%2C%20dramatic%20lighting%20with%20warm%20orange%20and%20deep%20black%20tones%2C%20cinematic%20composition%2C%20movie%20poster%20style%20with%20Chinese%20text%20space%2C%20grand%20scale%2C%20high%20contrast%2C%20dark%20atmosphere&width=800&height=1120&seq=lulu-hero-01&orientation=portrait',
    description: '太阳急速老化，持续膨胀，地球面临被吞没的危机。人类再次联合起来，在地球表面建造出巨大的推进器，寻找新的家园。在这场关乎人类命运的旅程中，无数人挺身而出，上演了可歌可泣的壮丽篇章。',
    duration: '148分钟',
    director: '郭帆',
    actors: ['吴京', '刘德华', '李雪健', '沙溢'],
    region: '中国大陆',
    tags: ['科幻', '灾难', '冒险', 'IMAX'],
    isHot: true,
    isNew: true,
    updateDate: '2026-07-28',
  },
  {
    id: '2',
    slug: 'man-jiang-hong-2',
    title: '满江红2',
    titleEn: 'Full River Red 2',
    year: 2026,
    category: '剧情片',
    categorySlug: 'drama',
    rating: 8.8,
    poster: 'https://readdy.ai/api/search-image?query=Chinese%20historical%20drama%20movie%20poster%2C%20ancient%20Chinese%20warriors%20in%20red%20and%20black%20armor%2C%20dramatic%20palace%20courtyard%20scene%2C%20cinematic%20lighting%2C%20intense%20atmosphere%2C%20dark%20moody%20background%2C%20movie%20poster%20aesthetic&width=800&height=1120&seq=lulu-hero-02&orientation=portrait',
    description: '南宋绍兴年间，岳飞死后四年，秦桧率兵与金国会谈。会谈前夜，金国使者死在宰相驻地，所携密信也不翼而飞。一个小兵与亲兵营副统领机缘巧合被裹挟进这巨大阴谋之中。',
    duration: '159分钟',
    director: '张艺谋',
    actors: ['沈腾', '易烊千玺', '张译', '雷佳音'],
    region: '中国大陆',
    tags: ['历史', '悬疑', '喜剧'],
    isHot: true,
    isNew: false,
    updateDate: '2026-07-15',
  },
  {
    id: '3',
    slug: 'ne-zha-3',
    title: '哪吒之魔童闹海',
    titleEn: 'Ne Zha 3',
    year: 2026,
    category: '动画片',
    categorySlug: 'animation',
    rating: 9.5,
    poster: 'https://readdy.ai/api/search-image?query=Chinese%20animated%20movie%20poster%2C%20mythological%20young%20warrior%20with%20flaming%20wheels%20and%20red%20ribbon%2C%20dynamic%20action%20pose%2C%20fire%20and%20water%20elements%2C%20vibrant%20red%20and%20gold%20colors%2C%20dark%20dramatic%20background%2C%20epic%20cinematic%20style&width=800&height=1120&seq=lulu-hero-03&orientation=portrait',
    description: '天劫之后，哪吒和敖丙虽然保住了灵魂，但肉身很快就要魂飞魄散。太乙真人打算用七色宝莲给二人重塑肉身，但是在重塑肉身的过程中却遇到重重困难，哪吒、敖丙的命运将走向何方？',
    duration: '144分钟',
    director: '饺子',
    actors: ['吕艳婷', '囧森瑟夫', '瀚墨'],
    region: '中国大陆',
    tags: ['动画', '神话', '奇幻', '3D'],
    isHot: true,
    isNew: true,
    updateDate: '2026-08-01',
  },
];

export const movies: MovieItem[] = [
  ...heroMovies,
  {
    id: '4',
    slug: 'feng-shen-di-er-bu',
    title: '封神第二部：战火西岐',
    titleEn: 'Creation of the Gods II',
    year: 2026,
    category: '动作片',
    categorySlug: 'action',
    rating: 8.5,
    poster: 'https://readdy.ai/api/search-image?query=Epic%20Chinese%20mythological%20war%20movie%20poster%2C%20ancient%20Chinese%20general%20on%20horseback%20with%20army%20behind%2C%20golden%20and%20crimson%20battle%20flags%2C%20dramatic%20stormy%20sky%2C%20cinematic%20grand%20scale%2C%20dark%20atmospheric%20tones&width=800&height=1120&seq=lulu-movie-04&orientation=portrait',
    description: '殷商大军兵临西岐，姜子牙与姬发带领西岐军民奋起反抗。在这场关乎天下苍生的大战之中，各方势力暗流涌动，封神榜的秘密也逐渐浮出水面。',
    duration: '150分钟',
    director: '乌尔善',
    actors: ['费翔', '李雪健', '黄渤', '于适'],
    region: '中国大陆',
    tags: ['神话', '战争', '奇幻', '史诗'],
    isHot: true,
    isNew: false,
    updateDate: '2026-07-20',
  },
  {
    id: '5',
    slug: 're-la-gun-tang',
    title: '热辣滚烫',
    titleEn: 'YOLO',
    year: 2024,
    category: '喜剧片',
    categorySlug: 'comedy',
    rating: 8.3,
    poster: 'https://readdy.ai/api/search-image?query=Chinese%20comedy%20drama%20movie%20poster%2C%20confident%20woman%20boxing%20in%20a%20gym%2C%20sweat%20and%20determination%2C%20warm%20golden%20lighting%2C%20inspirational%20atmosphere%2C%20cinematic%20poster%20style%2C%20dark%20background%20with%20warm%20highlights&width=800&height=1120&seq=lulu-movie-05&orientation=portrait',
    description: '乐莹是一个善良的女孩，但她发现自己的善良换来的却是伤害。在经历了一系列挫折后，她决定通过拳击改变自己，开始了热辣滚烫的人生新篇章。',
    duration: '129分钟',
    director: '贾玲',
    actors: ['贾玲', '雷佳音', '张小斐', '杨紫'],
    region: '中国大陆',
    tags: ['喜剧', '励志', '运动', '女性'],
    isHot: false,
    isNew: false,
    updateDate: '2026-07-10',
  },
  {
    id: '6',
    slug: 'du-she-xing-dong',
    title: '毒舌律师',
    titleEn: 'A Guilty Conscience',
    year: 2023,
    category: '剧情片',
    categorySlug: 'drama',
    rating: 8.7,
    poster: 'https://readdy.ai/api/search-image?query=Hong%20Kong%20legal%20drama%20movie%20poster%2C%20confident%20lawyer%20in%20courtroom%2C%20dramatic%20lighting%2C%20serious%20expression%2C%20scales%20of%20justice%20symbolism%2C%20dark%20moody%20courtroom%20background%2C%20cinematic%20style&width=800&height=1120&seq=lulu-movie-06&orientation=portrait',
    description: '一宗看似简单的虐儿案，背后却隐藏着豪门权贵的惊天阴谋。毒舌律师林凉水凭借三寸不烂之舌，在法庭上与权贵势力展开了一场惊心动魄的较量。',
    duration: '133分钟',
    director: '吴炜伦',
    actors: ['黄子华', '谢君豪', '王丹妮', '廖子妤'],
    region: '中国香港',
    tags: ['律政', '剧情', '悬疑'],
    isHot: false,
    isNew: false,
    updateDate: '2026-07-05',
  },
  {
    id: '7',
    slug: 'xiao-shi-de-ta',
    title: '消失的她',
    titleEn: 'Lost in the Stars',
    year: 2023,
    category: '悬疑片',
    categorySlug: 'drama',
    rating: 8.4,
    poster: 'https://readdy.ai/api/search-image?query=Mystery%20thriller%20movie%20poster%2C%20woman%20looking%20into%20mirror%20with%20mysterious%20reflection%2C%20dark%20blue%20and%20gold%20tones%2C%20suspenseful%20atmosphere%2C%20cinematic%20noir%20style%2C%20deep%20shadows%2C%20psychological%20thriller%20aesthetic&width=800&height=1120&seq=lulu-movie-07&orientation=portrait',
    description: '何非的妻子在海外度假时离奇失踪。当他报案后，一个陌生女人突然出现，声称自己就是他的妻子。何非陷入了身份认知的巨大危机，真相远比想象中更加黑暗。',
    duration: '121分钟',
    director: '崔睿',
    actors: ['朱一龙', '倪妮', '文咏珊', '杜江'],
    region: '中国大陆',
    tags: ['悬疑', '犯罪', '心理'],
    isHot: false,
    isNew: false,
    updateDate: '2026-06-28',
  },
  {
    id: '8',
    slug: 'chang-an-san-wan-li',
    title: '长安三万里',
    titleEn: 'Chang An',
    year: 2023,
    category: '动画片',
    categorySlug: 'animation',
    rating: 9.0,
    poster: 'https://readdy.ai/api/search-image?query=Chinese%20animated%20historical%20movie%20poster%2C%20ancient%20Tang%20dynasty%20cityscape%20with%20poets%2C%20golden%20palace%20and%20flying%20cranes%2C%20traditional%20Chinese%20painting%20style%2C%20warm%20golden%20and%20jade%20green%20tones%2C%20poetic%20atmosphere%2C%20dark%20elegant%20background&width=800&height=1120&seq=lulu-movie-08&orientation=portrait',
    description: '安史之乱爆发后数年，吐蕃大军攻打西南。大唐节度使高适交战中回忆自己与李白的一生往事，两位诗人跌宕起伏的命运与大唐由盛转衰的历史交织在一起。',
    duration: '168分钟',
    director: '谢君伟',
    actors: ['杨天翔', '凌振赫', '吴俊全'],
    region: '中国大陆',
    tags: ['动画', '历史', '诗歌', '传记'],
    isHot: false,
    isNew: false,
    updateDate: '2026-06-20',
  },
  {
    id: '9',
    slug: 'gu-zhu-yi-zhi',
    title: '孤注一掷',
    titleEn: 'No More Bets',
    year: 2023,
    category: '犯罪片',
    categorySlug: 'drama',
    rating: 8.6,
    poster: 'https://readdy.ai/api/search-image?query=Crime%20thriller%20movie%20poster%2C%20intense%20close-up%20of%20man%20looking%20at%20computer%20screen%2C%20digital%20numbers%20reflected%20in%20eyes%2C%20dark%20red%20and%20black%20tones%2C%20gritty%20realistic%20style%2C%20tension%20and%20danger%20atmosphere&width=800&height=1120&seq=lulu-movie-09&orientation=portrait',
    description: '程序员潘生和模特梁安娜被海外高薪招聘吸引，却意外陷入境外诈骗工厂的陷阱。他们为了逃离魔窟，不得不配合诈骗集团进行更大规模的犯罪活动。',
    duration: '130分钟',
    director: '申奥',
    actors: ['张艺兴', '金晨', '咏梅', '王传君'],
    region: '中国大陆',
    tags: ['犯罪', '剧情', '诈骗', '真实事件'],
    isHot: false,
    isNew: false,
    updateDate: '2026-06-15',
  },
  {
    id: '10',
    slug: 'yu-gu-yao',
    title: '玉骨遥',
    titleEn: 'The Longest Promise',
    year: 2026,
    category: '电视剧',
    categorySlug: 'tv',
    rating: 8.1,
    poster: 'https://readdy.ai/api/search-image?query=Chinese%20fantasy%20romance%20drama%20poster%2C%20ethereal%20couple%20in%20flowing%20white%20and%20red%20robes%2C%20floating%20in%20magical%20sky%20with%20petals%2C%20dreamy%20atmospheric%20lighting%2C%20ancient%20Chinese%20aesthetic%2C%20dark%20mystical%20background&width=800&height=1120&seq=lulu-movie-10&orientation=portrait',
    description: '孤高清冷的空桑皇太子时影和热情仗义的赤族郡主朱颜，因一花之恩结下命劫夙缘，两人为了守护空桑王朝而共同成长。一段刻骨铭心的仙侠奇缘就此展开。',
    duration: '40集',
    director: '蒋家骏',
    actors: ['肖战', '任敏', '方逸伦', '王楚然'],
    region: '中国大陆',
    tags: ['古装', '仙侠', '爱情', '奇幻'],
    isHot: true,
    isNew: true,
    updateDate: '2026-07-25',
  },
  {
    id: '11',
    slug: 'kuang-biao',
    title: '狂飙',
    titleEn: 'The Knockout',
    year: 2023,
    category: '电视剧',
    categorySlug: 'tv',
    rating: 9.3,
    poster: 'https://readdy.ai/api/search-image?query=Chinese%20crime%20drama%20TV%20series%20poster%2C%20two%20men%20facing%20each%20other%20in%20dark%20alley%2C%20police%20and%20gangster%20confrontation%2C%20gritty%20realistic%20style%2C%20dark%20blue%20and%20amber%20lighting%2C%20intense%20dramatic%20atmosphere&width=800&height=1120&seq=lulu-movie-11&orientation=portrait',
    description: '京海市一线刑警安欣在与黑恶势力的斗争中，遭到保护伞的打击，始终无法将犯罪分子绳之以法。全国政法队伍教育整顿工作开展后，临江省派出指导组入驻京海，联合安欣彻底铲除盘踞多年的黑恶势力。',
    duration: '39集',
    director: '徐纪周',
    actors: ['张译', '张颂文', '李一桐', '张志坚'],
    region: '中国大陆',
    tags: ['犯罪', '剧情', '扫黑', '悬疑'],
    isHot: true,
    isNew: false,
    updateDate: '2026-07-18',
  },
  {
    id: '12',
    slug: 'qing-yu-nian-2',
    title: '庆余年第二季',
    titleEn: 'Joy of Life Season 2',
    year: 2026,
    category: '电视剧',
    categorySlug: 'tv',
    rating: 8.9,
    poster: 'https://readdy.ai/api/search-image?query=Chinese%20historical%20political%20drama%20poster%2C%20young%20scholar%20in%20elegant%20robe%20standing%20in%20ancient%20palace%2C%20scheming%20expression%2C%20golden%20and%20deep%20red%20colors%2C%20palace%20intrigue%20atmosphere%2C%20dark%20luxurious%20background&width=800&height=1120&seq=lulu-movie-12&orientation=portrait',
    description: '范闲在经历了一系列生死考验后，继续书写着自己不平凡的人生。他深入南庆皇室内部的权力斗争中，用自己的智慧和勇气，一步步揭开身世之谜。第二季剧情更加跌宕起伏。',
    duration: '36集',
    director: '孙皓',
    actors: ['张若昀', '李沁', '陈道明', '吴刚'],
    region: '中国大陆',
    tags: ['古装', '权谋', '玄幻', '喜剧'],
    isHot: true,
    isNew: true,
    updateDate: '2026-08-01',
  },
];

export const brandInfo = {
  name: '鲁鲁影院',
  slogan: '高清免费在线不缓冲',
  description: '鲁鲁影院致力于为广大影迷提供最优质的在线观影体验。我们拥有海量正版影视资源，涵盖电影、电视剧、综艺、动漫等多种类型，每日更新热播内容。高清画质、流畅播放、无需缓冲，让您随时随地畅享追剧乐趣。',
  established: '2020年',
  users: '超过5000万',
  content: '超过10万部',
  dailyUpdate: '每日更新50+',
  features: [
    { title: '高清画质', description: '支持1080P高清画质，给您影院级观影体验', icon: 'ri-4k-line' },
    { title: '流畅播放', description: '全球CDN加速，无需缓冲，即点即播', icon: 'ri-speed-up-line' },
    { title: '海量资源', description: '收录超过10万部影视作品，类型丰富齐全', icon: 'ri-film-line' },
    { title: '每日更新', description: '每日更新50+部热播内容，追剧快人一步', icon: 'ri-calendar-check-line' },
    { title: '完全免费', description: '所有内容完全免费观看，无需任何付费', icon: 'ri-money-cny-circle-line' },
    { title: '多端适配', description: '支持电脑、平板、手机多端观看', icon: 'ri-smartphone-line' },
  ],
  contact: {
    email: 'support@lulucinema.com',
    wechat: '鲁鲁影院官方',
    weibo: '@鲁鲁影院',
    address: '北京市朝阳区光华路甲8号和乔大厦',
  },
};

export const testimonials = [
  {
    id: '1',
    name: '小张',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20young%20Asian%20man%2C%20friendly%20smile%2C%20clean%20background%2C%20warm%20lighting&width=100&height=100&seq=lulu-avatar-01&orientation=squarish',
    rating: 5,
    content: '鲁鲁影院太好用了！画质清晰，缓冲速度也快，终于找到了一个靠谱的免费观影平台。每天下班回家就打开鲁鲁影院追剧，已经推荐给身边所有朋友了！',
    date: '2026-07-25',
  },
  {
    id: '2',
    name: '小李',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20young%20Asian%20woman%2C%20warm%20smile%2C%20clean%20background%2C%20soft%20lighting&width=100&height=100&seq=lulu-avatar-02&orientation=squarish',
    rating: 5,
    content: '资源真的很全，想看的电影基本都能找到。更新速度也快，热播剧当天就能看，再也不用到处找资源了。高清免费在线不缓冲，名副其实！',
    date: '2026-07-20',
  },
  {
    id: '3',
    name: '老王',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20middle-aged%20Asian%20man%2C%20confident%20expression%2C%20clean%20background%2C%20natural%20lighting&width=100&height=100&seq=lulu-avatar-03&orientation=squarish',
    rating: 5,
    content: '作为一个电影爱好者，鲁鲁影院的片库深度让我惊喜。很多经典老片和冷门佳作都有收录，画质也都做了高清修复。真心推荐给所有喜欢看电影的朋友。',
    date: '2026-07-15',
  },
];

export const faqs = [
  {
    question: '鲁鲁影院是否需要注册？',
    answer: '鲁鲁影院完全免费，不需要注册即可观看所有内容。我们致力于为用户提供最简单便捷的观影体验，无需任何繁琐的注册流程。',
  },
  {
    question: '支持哪些设备观看？',
    answer: '鲁鲁影院支持电脑（Windows/Mac）、平板（iPad/Android）、手机（iOS/Android）等多种设备。您可以在任何有网络的设备上畅享观影体验。',
  },
  {
    question: '视频画质如何？',
    answer: '我们提供1080P高清画质，部分影片支持4K超清画质。采用先进的视频编码技术，在保证画质的同时优化带宽占用，让您流畅观影。',
  },
  {
    question: '如何搜索想看的影片？',
    answer: '您可以使用首页顶部的搜索框直接搜索影片名称，也可以通过分类导航浏览不同类型的影片。我们还在不断优化搜索功能，为您提供更好的体验。',
  },
  {
    question: '影片多久更新一次？',
    answer: '鲁鲁影院每日更新，热播电视剧和综艺节目通常在播出后数小时内即可观看。电影也会在上映后第一时间上线，让您不错过任何精彩内容。',
  },
  {
    question: '遇到播放问题怎么办？',
    answer: '如果您遇到播放卡顿或无法播放的情况，建议尝试切换清晰度或刷新页面。如果问题持续，可以通过关于我们页面的联系方式与我们取得联系，我们会尽快解决。',
  },
];